/* eslint max-classes-per-file: 0 */

import {
  CollectorPublication as Data,
  CollectorPublicationCollection as Collection,
} from '@/typings/api/CollectorPublication'

import { BaseCollectorApiAuth } from '@/api/BaseApiAuth'

export class CollectorPublicationsApi extends BaseCollectorApiAuth<Data, Collection> {
  protected readonly endpoint = 'publications';

  protected readonly hasFinishSlash = false;

  public deleteEmpty(id: string | number) {
    const [url] = this.getUrl(`${id}/delete-empty`)
    return this.request<never>('POST', url)
  }
}
